// extracted by mini-css-extract-plugin
module.exports = {"outer":"style-module--outer--29OJQ","title":"style-module--title--38lYd","dark":"style-module--dark--2yTnj"};